import { categories } from "@/mocks/categories";

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[680px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20abstract%20flowing%20composition%20with%20soft%20organic%20shapes%20in%20cream%20terracotta%20and%20beige%20tones%2C%20modern%20minimalist%20gradient%20backdrop%20with%20delicate%20texture%2C%20bright%20airy%20atmosphere%20with%20subtle%20geometric%20accents%2C%20elegant%20editorial%20aesthetic%2C%20clean%20open%20composition%20with%20ample%20whitespace%20and%20warm%20inviting%20feel&width=1600&height=900&seq=hero-bg-vigorbuy-v2&orientation=landscape"
          alt="Vigorbuy Spreadsheet background"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full max-w-5xl mx-auto px-4 md:px-6 py-20 md:py-24 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-6">
          Master Vigorbuy Spreadsheet With Complete Guides, Templates &amp; Expert Insights
        </h1>
        <p className="text-base md:text-lg text-white/80 max-w-3xl mx-auto mb-10 leading-relaxed">
          Everything you need to understand Vigorbuy Spreadsheet — from beginner tutorials and advanced templates to comparisons, security tips and productivity strategies.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 text-base font-label font-semibold bg-primary-500 text-background-50 rounded-md hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Vigorbuy Spreadsheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 text-base font-label font-semibold bg-white/10 backdrop-blur-sm text-white border border-white/30 rounded-md hover:bg-white/20 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Buy It Now
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 text-white/70 text-xs md:text-sm">
          <span className="flex items-center gap-1.5">
            <i className="ri-checkbox-circle-fill text-accent-400"></i>
            Updated Spreadsheet Resources
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-checkbox-circle-fill text-accent-400"></i>
            Expert Comparison Guides
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-checkbox-circle-fill text-accent-400"></i>
            Secure Usage Information
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-checkbox-circle-fill text-accent-400"></i>
            Beginner Friendly Tutorials
          </span>
        </div>

        <div className="mt-14">
          <p className="text-white/60 text-xs md:text-sm mb-4 font-label">
            Browse by category — shop directly on kaspreadsheet.com
          </p>
          <div className="relative inline-block w-full sm:w-72">
            <select
              onChange={(e) => {
                if (e.target.value) {
                  window.open(e.target.value, "_blank", "noopener,noreferrer");
                }
              }}
              className="w-full appearance-none px-5 py-3 pr-10 bg-white/10 backdrop-blur-sm border border-white/20 rounded-md text-white text-sm font-label cursor-pointer focus:outline-none focus:ring-2 focus:ring-primary-400/50"
              defaultValue=""
            >
              <option value="" disabled className="text-foreground-700">
                Select a category...
              </option>
              {categories.map((cat) => (
                <option key={cat.name} value={cat.url} className="text-foreground-700">
                  {cat.name}
                </option>
              ))}
            </select>
            <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none">
              <i className="ri-arrow-down-s-line text-white/70 text-lg"></i>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}